/* globals console, module, require, setTimeout */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const async = require('async'),
    Backbone = require('backbone'),
    _ = require('lodash'),
    //
    Image = require('../models/image'),
    user = require('../models/user'),
    //
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    templates = require('../utilities/handlebars').templates,
    // user = require('../models/user'),
    columns = {
        urlThumb: {
            type: 'img',
            display: ''
        },
        caption: {
            type: 'text',
            display: 'Caption'
        },
        originalFileName: {
            type: 'text',
            display: 'Filename'
        },
        moveUp: {
            type: 'action',
            display: '',
            action: 'move:up',
            src: configuration.assetBase + 'images/moveUp.svg',
            srcDisabled: configuration.assetBase + 'images/moveUp_disabled.svg'
        },
        moveDown: {
            type: 'action',
            display: '',
            action: 'move:down',
            src: configuration.assetBase + 'images/moveDown.svg',
            srcDisabled: configuration.assetBase + 'images/moveDown_disabled.svg'
        },
        edit: {
            type: 'action',
            display: '',
            action: 'edit',
            src: configuration.assetBase + 'images/edit.svg'
        }
    },
    EOL = null;

module.exports = Backbone.Collection.extend({
    model: Image,
    comparator: function (a, b) {
        return a.attributes.order - b.attributes.order;
    },
    url: function () {
        return configuration.apiUrlBase + 'programImages/' + this.programId;
    },
    //
    columns: function (raw) {
        let a = [];
        a = _.map(columns, function (column, key) {
            var o = {
                name: key,
                display: column.display,
                src: column.src
            };
            o[column.type] = true;
            return o;
        });
        return a;
    },
    initialize: function (models, options) {
        this.programId = options.programId;
        this.fetch();
    },
    move: function (modelId, direction) {
        const currentModel = this.get(modelId),
            currentIndex = this.indexOf(currentModel);
        let otherModel, otherIndex;
        if (direction === 'down' ? currentIndex < this.length - 1 : currentIndex > 0) {
            otherIndex = currentIndex + (direction === 'down' ? 1 : -1);
            otherModel = this.models[otherIndex];
            this.models[currentIndex] = otherModel;
            this.models[otherIndex] = currentModel;
            this.touchUpOrders();
            this.updateAll();
        }
    },
    moveDown: function (modelId) {
        this.move(modelId, 'down');
    },
    moveUp: function (modelId) {
        this.move(modelId, 'up');
    },
    // parse: function (results) {
    //     console.log('images.parse');
    //     _.each(results, function (result) {
    //         console.log(result.order, result.caption);
    //     });
    //     return results;
    // },
    rows: function () {
        let a = [],
            properties = _.keys(columns);
        if (this.length) {
            _.each(this.models, _.bind(function (model) {
                let json = model.toJSON(),
                    display = {
                        id: json.id,
                        context: 'display',
                        display: true,
                        values: {}
                    },
                    edit = {
                        id: json.id,
                        context: 'edit',
                        edit: true,
                        colspan: 6,
                        hidden: true,
                        values: {}
                    };
                _.each(properties, function (property) {
                    switch (columns[property].type) {
                        case 'img':
                            display.values[property] = '<img class="thumbnail fragile" src="' + json[property] + '"' + (json.captionX ? 'title="' + json.caption + '"' : '') + '/>';
                            break;
                        case 'action':
                            if (property === 'edit') {
                                display.values.edit = templates.tableEditButton(_.invert({true: configuration.tableEditButtonStyle}));
                            } else {
                                display.values[property] = '<img src="' + columns[property].src + '" data-action="' + property + '" class="action_enabled column-icon align-text-bottom"/><img src="' + columns[property].srcDisabled + '" data-action="noop" class="action_disabled column-icon align-text-bottom"/>';
                            }
                            break;
                        default:
                            display.values[property] = json[property];
                            break;
                    }
                });
                a.push(display);
                edit.values = {
                    form: templates.imageEdit(json)
                };
                a.push(edit);
            }, this));
        }
        return a;
    },
    sortAttributeDISABLED: function (attributeOrder) {
        // it's not clear how have to support both sortable columns and move up and move down
        // so disabled sortable columns for now...
    },
    touchUpOrders: function () {
        // console.log('images.touchUpOrders - before');
        // this.models.forEach(function (model, index) {
        //     console.log(model.get('order'), model.get('caption'));
        // });
        this.models.forEach(function (model, index) {
            model.set('order', (index + 1) * 100);
        });
        // console.log('images.touchUpOrders - after');
        // this.models.forEach(function (model, index) {
        //     console.log(model.get('order'), model.get('caption'));
        // });
    },
    update: function (serializedValues) {
        const processedValues = formProcessor(serializedValues, 'images'),
            image = this.get(processedValues.id);
        image.set(processedValues);
        if (!_.isEmpty(image.changed)) {
            image.save();
        }
    },
    updateAll: function () {
        // console.log('images.update');
        async.each(this.models, function (model, callback) {
            if (model.hasChanged()) {
                // console.log(model.get('order'), model.get('caption'));
                model.sync('update', model, {
                    success: function () {
                        callback(null);
                    }
                });
            } else {
                callback(null);
            }
        }, _.bind(function () {
            // console.log('images.update.fetch');
            this.fetch();
        }, this));
    }
});
